import PropTypes from 'prop-types';
import React from 'react';
import Backdrop from '@mui/material/Backdrop';

function CommonBackdrop({ open, role = 'presentation', ariaLabel, children }) {
	return (
		<Backdrop
			role={role}
			aria-label={ariaLabel}
			sx={{
				color: 'primary',
				zIndex: (theme) => theme.zIndex.drawer + 1,
				backgroundColor: 'transparent',
			}}
			open={open}
		>
			{children}
		</Backdrop>
	);
}

CommonBackdrop.propTypes = {
	ariaLabel: PropTypes.string,
	children: PropTypes.node,
	open: PropTypes.bool.isRequired,
	role: PropTypes.string,
};

export default CommonBackdrop;
